import axios from 'axios';
import { requestFailed } from '../InvoicingCycle/invoicingCycleApi';

const ENTRATA_TEST_RUN = '/qa-tools/entrata-test-run';

// The tools answer 404 outside QA and local; the page says so itself, so the app-wide
// error flash would only repeat it.
const QUIET = { suppressErrorFlash: true };

export const fetchEntrataTestProperties = async () => {
  const response = await axios.get(`${ENTRATA_TEST_RUN}/properties`, QUIET);

  if (requestFailed(response)) {
    return { available: false, properties: [] };
  }

  return { available: true, properties: response.data.properties };
};

export const downloadEntrataExample = async entrataId => {
  const response = await axios.get(`${ENTRATA_TEST_RUN}/${entrataId}/example`, { responseType: 'blob', ...QUIET });

  if (requestFailed(response)) {
    return { errors: `The example file could not be downloaded (status ${response?.status}).` };
  }

  return { file: response.data };
};

export const runEntrataTest = async (entrataId, file) => {
  const body = new FormData();
  body.append('file', file);

  const response = await axios.post(`${ENTRATA_TEST_RUN}/${entrataId}`, body, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...QUIET,
  });

  if (requestFailed(response)) {
    return { errors: response?.data?.message || `The run could not be completed (status ${response?.status}).` };
  }

  return { residents: response.data.residents };
};

const CORT_ACTIVATION = '/qa-tools/cort-activation';
// The QA Tools answer 404 only where they do not exist.
const NOT_FOUND = 404;

export const lookUpCortPerson = async email => {
  const response = await axios.get(`${CORT_ACTIVATION}/person`, { params: { email }, ...QUIET });

  if (response?.status === NOT_FOUND) {
    return { available: false, person: null };
  }
  if (requestFailed(response)) {
    return { available: true, person: null, errors: `The person could not be looked up (status ${response?.status}).` };
  }

  return { available: true, person: response.data.person };
};

export const moveCortPersonForward = async (userId, days) => {
  const response = await axios.post(`${CORT_ACTIVATION}/person/${userId}/move-forward`, { days }, QUIET);

  if (requestFailed(response)) {
    return { errors: response?.data?.message || `The person could not be moved forward (status ${response?.status}).` };
  }

  return { person: response.data.person };
};

export const runCortNightly = async () => {
  const response = await axios.post(`${CORT_ACTIVATION}/run-nightly`, {}, QUIET);

  if (requestFailed(response)) {
    return { errors: response?.data?.message || `The nightly job could not be run (status ${response?.status}).` };
  }

  return { ran: true };
};

export const addCortPersonThroughSalesforce = async newAgent => {
  const response = await axios.post(`${CORT_ACTIVATION}/add-through-salesforce`, newAgent, QUIET);

  if (requestFailed(response)) {
    return { errors: response?.data?.message || `The person could not be added (status ${response?.status}).` };
  }

  return { person: response.data.person };
};

const PROCESS_PENDING_IMPORTS = '/qa-tools/imports/process-pending';

export const processPendingImports = async () => {
  const response = await axios.post(PROCESS_PENDING_IMPORTS, {}, QUIET);

  if (response?.status === NOT_FOUND) {
    return { available: false, processed: [] };
  }
  if (requestFailed(response)) {
    return { available: true, processed: [], errors: `The uploaded files could not be processed (status ${response?.status}).` };
  }

  return { available: true, processed: response.data.processed };
};

const LAST_MONTHS_USAGE_FEE = '/qa-tools/invoice-preview/last-months-usage-fee';

export const postLastMonthsUsageFee = async programId => {
  const response = await axios.post(LAST_MONTHS_USAGE_FEE, { program_id: programId }, QUIET);

  if (response?.status === NOT_FOUND) {
    return { available: false };
  }
  if (requestFailed(response)) {
    const reason = response?.data?.errors?.program_id?.[0] || response?.data?.message;
    return { available: true, errors: reason || `The fee could not be posted (status ${response?.status}).` };
  }

  return { available: true, posted: response.data };
};
